import {Token, type TokenProps} from '@primer/react'

import MemexAvatarStack, {type MemexAvatarStackItem} from '../memex-avatar-stack'

type TokenSizeKeys = NonNullable<TokenProps['size']>

export interface AvatarsTokenProps extends Omit<TokenProps, 'leadingVisual' | 'ref'> {
  avatars: Array<MemexAvatarStackItem>
  ref?: React.Ref<HTMLElement>
}

export const tokenIconSize = (size: TokenSizeKeys = 'medium') =>
  size === 'small' ? 10 : size === 'medium' ? 14 : size === 'large' ? 16 : 24

/**
 * PRC offers an `AvatarToken` component, but it can only show one avatar. This can show up to three in a stack,
 * truncating with a '+X' icon beyond that.
 */
export const AvatarsToken = ({ref, avatars, ...tokenProps}: AvatarsTokenProps) => (
  <Token
    leadingVisual={() => (
      <MemexAvatarStack
        avatarColor="var(--bgColor-default)"
        items={avatars}
        size={tokenIconSize(tokenProps.size) - 1}
        maxVisible={3}
      />
    )}
    ref={ref}
    {...tokenProps}
  />
)
AvatarsToken.displayName = 'AvatarsToken'
